exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Return index of matched value in list */\n.header {\n  width: 100%;\n  height: 6.4rem;\n  background: #2a1c55;\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0 2rem;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #ffffff;\n  z-index: 60; }\n  .header__logo {\n    font-family: \"Karla\", \"Helvetica Neue\", \"Helvetica\", sans-serif;\n    font-size: 2.4rem;\n    font-weight: 700;\n    letter-spacing: -0.03em;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-pack: center;\n    justify-content: center; }\n    .header__logo svg {\n      fill: #ffffff;\n      width: 3.6rem;\n      height: 3.6rem;\n      margin-right: 1rem;\n      margin-top: 0.2rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader/lib?{"ident":"postcss"}!./src/components/Header.scss
// module id = 412
// module chunks = 0